<template>
  <ym-loadmore class="student-gains-list-component"
               v-model="loading"
               :finished="allLoad"
               @load="fetchData"
  >
    <gain-list :list="data" />
  </ym-loadmore>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import GainList from '@/pages/StudentGains/components/StudentGainsList';
  import { getStudentGainsExplore } from '@/services/student-gains';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'StudentGainsExplore',
    components: {
      'ym-loadmore': Loadmore,
      GainList,
    },
    props: {
      start: Number,
      list: Array,
      id: {
        type: Number,
        default: 0,
      },
      type: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        nextStart: 0,
        data: [],
        allLoad: false,
        loading: false,
      };
    },
    watch: {
      start(val) {
        this.nextStart = val;
      },
      list(val) {
        this.data = val;
      },
    },
    methods: {
      async fetchData() {
        if (this.allLoad) return;
        this.loading = true;

        const { nextStart: start } = this;
        const data = await getStudentGainsExplore({
          start,
          limit: LIMIT,
          id: this.id,
          type: this.type,
        }, true);

        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }

        this.nextStart = data.start;
        this.data = [...this.data, ...data.list];

        this.loading = false;
      },
    },
    created() {
      this.nextStart = this.start;
      this.data = this.list;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .student-gains-list {
    &-wrap {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 @size-medium;
    }
  }
</style>
